import * as moment from "moment";
import { storage, database } from "../firebase";
import { auth } from "firebase";
import fetch from "node-fetch";

export const retrieveCompanyDetails = async (info) => {
  try {
    if (info.companyId) {
      const validation = await fetch(
        `/database/company-details/${info.companyId}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const response = await validation.json();
      if (response.error === null) {
        return { payload: response.payload, error: null };
      } else {
        throw "Error";
      }
    } else {
      throw "Error";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const updateCompanyDetails = async (info) => {
  try {
    if (info.companyId && info.details) {
      await database
        .collection("companies")
        .doc(info.companyId)
        .update({
          city: info.details.city ? info.details.city : "",
          email: info.details.email ? info.details.email : "",
          industry: info.details.industry ? info.details.industry : "",
          name: info.details.name ? info.details.name : "",
          postalCode: info.details.postalCode ? info.details.postalCode : "",
        });
      return { payload: info.details.name, error: null };
    } else {
      throw "Error";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const updateCompanyImage = async (details) => {
  try {
    if (details.image) {
      const storageRef = storage.ref();
      const uploadRef = storageRef.child(
        "hosting/company/" + details.companyId + "/thumbnail"
      );
      const upload = await uploadRef.put(details.image);

      const url = await upload.ref.getDownloadURL();
      await database
        .collection("companies")
        .doc(details.companyId)
        .update({ thumbnail: url });
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyImage = async (details) => {
  try {
    const response = await database
      .collection("companies")
      .doc(details.companyId)
      .get();
    if (response.exists) {
      return { payload: response.data().thumbnail, error: null };
    } else {
      return { payload: null, error: "Ingen bilde." };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteCompanyImage = async (details) => {
  try {
    const storageRef = storage.ref();
    const uploadRef = storageRef.child(
      "hosting/company/" + details.companyId + "/thumbnail"
    );
    await uploadRef.delete();
    await database
      .collection("companies")
      .doc(details.companyId)
      .update({ thumbnail: null });
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyTeam = async (details) => {
  try {
    const allMembers = [];
    const members = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("employees")
      .get();
    const administrators = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("administrators")
      .get();

    members.forEach((member) => {
      const single = retrieveDisplayName(member.id, member.data());
      if (single) {
        allMembers.push(single);
      }
    });

    administrators.forEach((admin) => {
      const single = retrieveDisplayName(admin.id, admin.data());
      if (single) {
        allMembers.push(single);
      }
    });

    return Promise.allSettled(allMembers).then((result) => {
      const remaining = [];
      for (var user in result) {
        if (result[user].status === "fulfilled") {
          remaining.push(result[user].value);
        }
      }
      return { payload: remaining, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveDisplayName = (id, data) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(id)
      .get()
      .then((info) => {
        if (info.exists) {
          resolve({
            name: `${info.data().firstName} ${info.data().lastName}`,
            id: id,
            timestamp: data.timestamp,
            role: data.role,
            status: data.status,
          });
        } else {
          throw new Error({ type: "not-validated", uid: info.uid });
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const retrieveCompanyReceipts = async (details) => {
  try {
    const paymentInfo = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("payment")
      .doc("stripe")
      .get();
    const customerId = paymentInfo.data().customerId;
    const request = await fetch(`/api/stripe/retrieve-invoices/${customerId}`, {
      headers: { "Content-Type": "application/json" },
    });
    const response = await request.json();
    return { payload: response, error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanySubscription = async (details) => {
  try {
    if (details.companyId) {
      const request = await fetch(
        `/api/stripe/retrieve-subscription/${details.companyId}`,
        { headers: { "Content-Type": "application/json" } }
      );
      const response = await request.json();
      if (response.error === null) {
        return { payload: response.payload, error: null };
      } else {
        throw response.error;
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteCompanySubscription = async (details) => {
  try {
    if (details.type && details.companyId && details.subscriptionId) {
      const request = await fetch(
        `/api/stripe/delete-subscription/${details.subscriptionId}/${details.type}/${details.companyId}/${details.channelRef}`,
        { method: "DELETE", headers: { "Content-Type": "application/json" } }
      );
      const response = await request.json();
      if (response.error === null) {
        return { payload: response.payload, error: null };
      } else {
        throw response.error;
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const sendCompanyInvitation = async (details) => {
  try {
    if (details.companyId && details.email && details.companyName) {
      details["uid"] = auth().currentUser?.uid;
      const request = await fetch(`/database/invite-user`, {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();
      if (response.error === null) {
        return { error: null };
      } else {
        throw response.error;
      }
    } else {
      throw "Du mangler påkrevd data for invitasjon.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchCompanyName = async (id) => {
  try {
    const details = await database.collection("companies").doc(id).get();
    return details.data().name;
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteCompany = async (details) => {
  try {
    const subscription = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("payment")
      .doc("stripe")
      .get();
    if (!subscription.exists) {
      await fetch(`/database/delete-company`, {
        method: "DELETE",
        body: JSON.stringify({
          userId: details.key,
          companyId: details.companyId,
        }),
        headers: { "Content-Type": "application/json" },
      });
      return { error: null };
    } else {
      throw new Error(
        "Du må slette ditt aktive abonnement før du sletter foretaket ditt."
      );
    }
  } catch (e) {
    throw new Error("Kunne ikke slette foretak.");
  }
};

export const removeMember = async (details) => {
  try {
    if (details.id !== auth().currentUser?.uid) {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("employees")
        .doc(details.id)
        .delete();
      return { error: null };
    } else {
      throw new Error("Du kan ikke slette deg selv fra et foretak.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const changeMember = async (details) => {
  try {
    const userInfo = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("employees")
      .doc(details.id)
      .get();
    if (userInfo.exists) {
      if (userInfo.data().role === details.role) {
        return { error: null };
      } else {
        await database
          .collection("companies")
          .doc(details.companyId)
          .collection("employees")
          .doc(details.id)
          .update({ role: details.role });
        return { error: null };
      }
    } else {
      throw new Error("Brukeren finnes ikke.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyPaymentMethods = async (details) => {
  try {
    if (details.companyId) {
      const request = await fetch(
        `/api/stripe/retrieve-payment-methods/${details.companyId}`,
        { headers: { "Content-Type": "application/json" } }
      );
      const response = await request.json();
      if (response.error === null) {
        return { error: null, payload: response.payload };
      } else {
        throw response.error;
      }
    } else {
      throw new Error("Kunne ikke finne bedrift.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveCompanyChannels = async (details) => {
  try {
    if (details.companyId) {
      const allChannels = [];
      const channels = await database
        .collection("companies")
        .doc(details.companyId)
        .collection("channels")
        .get();
      channels.forEach((channel) => {
        allChannels.push({
          id: channel.id,
          type: channel.data().type,
          username: channel.data().username,
          email: channel.data().email,
          userid: channel.data().userid,
          timestamp: channel.data().timestamp,
        });
      });

      return { payload: allChannels, error: null };
    } else {
      throw new Error("Kunne ikke finne bedrift.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deletePaymentMethod = async (details) => {
  try {
    if (details.methodId) {
      const request = await fetch(
        `/api/stripe/delete-payment-method/${details.methodId}`,
        { method: "DELETE" }
      );
      const response = await request.json();
      if (response.error === null) {
        return { payload: "success", error: null };
      } else {
        throw response.error;
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const addPaymentMethod = async (details) => {
  try {
    if (
      details.companyId &&
      details.card &&
      Object.keys(details.card).length > 0
    ) {
      const validation = await fetch(`/api/stripe/add-payment-method`, {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await validation.json();
      if (response.error === null) {
        return { error: null };
      } else {
        throw response.error;
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const updatePaymentMethod = async (details) => {
  try {
    if (details.companyId) {
      const validation = await fetch(`/api/stripe/update-payment-method`, {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await validation.json();
      if (response.error === null) {
        return { error: null };
      } else {
        throw response.error;
      }
    } else {
      throw "Kunne ikke finne bedrift.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const updateLicenseQuantity = async (details) => {
  try {
    const request = await fetch(`/api/stripe/update-license-quantity`, {
      method: "POST",
      body: JSON.stringify(details),
      headers: { "Content-Type": "application/json" },
    });
    const response = await request.json();
    if (response.error === null) {
      return { error: null };
    } else {
      throw response.error;
    }
  } catch (e) {
    throw new Error(e);
  }
};
